module.exports = __webpack_public_path__ + "assets/img/steering.111e15e0.png";